<template>
    <div class="pageContent">
        <forwardingReport />
    </div>
</template>
<script>
import forwardingReport from "@/components/reportInfo/forwardingReport.vue";
export default {
  name: "forwarding",
  components: { forwardingReport },
  data() {
    return {};
  },
  methods: {
  },
  mounted(){
    // console.log(JSON.parse(Storage.get('reportInfo'))[0].exam_id)
    // this.getMakeReportLink()
  }
};
</script>
<style lang="scss" scoped>
</style>
